import { Injectable } from '@angular/core';
import { map, switchMap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as GamesActions from '@app/core/store/games/games-actions';
import { GamesApiService } from '@app/games/services/games-api.service';
import { Game } from '@app/games/model/game';

@Injectable()
export class GamesEffects {

  public loadGames$ = createEffect(() => this.actions$.pipe(
    ofType(GamesActions.loadGames),
    switchMap(({ language }) => this.gamesApiService.getList(language)),
    map((games: Game[]) => GamesActions.gamesLoaded({ games })),
  ));

  constructor(
    private actions$: Actions,
    private gamesApiService: GamesApiService,
  ) {}

}
